import CTATilesBlock from './CTATilesBlock';

export default CTATilesBlock;
